
import React from "react";
import { Schemes } from "../../utils";
import { i18nManager } from "../../i18n";
import { PreviewLink } from "./PreviewLink";
import { Button, Checkbox, Classname, FileInput, FileInputMode, FormControl, NoseurObject, ObjectHelper, Scheme, TextInput } from "@rivtn/noseur";
import { Elements } from "../shared/Elements";

export interface ImportExportProps {
    section: string;
    export: () => Promise<void | string>;
    import: (settings: NoseurObject<string>) => Promise<void | string>;
}

function ImportExport(props: ImportExportProps) {

    const labels = i18nManager.Labels.import_export;
    const [importError, setImportError] = React.useState<string>();
    const [exportError, setExportError] = React.useState<string>();
    const [settings, setSettings] = React.useState<NoseurObject<string>>();
    const [selectedFileName, setSelectedFileName] = React.useState<string>();

    return (<div className="inexport">
        <div className="section">
            <span className="t">{labels.export_settings}</span>
            <span className="d">{labels.export_settings_desc}</span>
            {exportError && (<span className="noseur-danger-tx">{exportError}</span>)}
            <Button raised scheme={Schemes.OMNEHOST} text={labels.export} style={{ padding: "10px 35px" }} loadingProps={Elements.BUTTON_LOADING_PROPS}
                onClick={async ({ manageRef }) => {
                    setImportError(undefined);
                    setExportError(undefined);
                    manageRef?.setLoadingState(true);
                    await reportPromErrorOnly(props.export(), setExportError);
                    manageRef?.setLoadingState(false);
                }} />
        </div>
        <div className="section" style={{ marginTop: 20 }}>
            <span className="t">{labels.import_settings}</span>
            <span className="d">{labels.import_settings_desc}</span>
            <FormControl isFieldset fill label={labels.choose_settings_file} invalid={!!importError}
                rightContent={<FileInput scheme={Schemes.OMNEHOST} mode={FileInputMode.BUTTON} buttonProps={{ outlined: false, style: { margin: 5, padding: "7px 15px" } }}
                    accepts=".json, application/json" onSelectFiles={async ([file, ..._]) => {
                        setImportError(undefined);
                        setExportError(undefined);
                        setSelectedFileName(file.name);
                        setSettings(JSON.parse(await file.text()));
                    }} />}>
                <TextInput highlight value={selectedFileName} readOnly fill />
            </FormControl>
            {settings && (<span dangerouslySetInnerHTML={{ __html: labels.copy_from.replace("${name}", settings.name) }} />)}
            {importError && (<span className="noseur-danger-tx">{importError}</span>)}
            <Button raised scheme={Schemes.OMNEHOST} text={labels.confirm_import} style={{ padding: "10px 35px" }} loadingProps={Elements.BUTTON_LOADING_PROPS}
                onClick={async ({ manageRef }) => {
                    if (!settings) {
                        setImportError(labels.select_file);
                        return;
                    }
                    setImportError(undefined);
                    setExportError(undefined);
                    manageRef?.setLoadingState(true);
                    await reportPromErrorOnly(props.import(settings), setImportError);
                    manageRef?.setLoadingState(false);
                }} />
        </div>
        <Checkbox scheme={Schemes.OMNEHOST} label={labels.allow_checkbox[props.section]} style={{ marginTop: 20 }} />
    </div>);

    async function reportPromErrorOnly<T>(prom: Promise<T>, onError: (v: string) => void) {
        try {
            const result = await prom;
            if (typeof result === "string") {
                onError(result);
            }
        } catch (err) {
            onError(`${err}`);
        }
    }

}

export default ImportExport;
